import React from 'react';
import { observer } from 'mobx-react';

import decorator from 'lib/lang/decorator';
import withInnerRef from 'lib/react/with-inner-ref';
import { RetryDialog, InfoDialog } from 'lib/alerts/dialog';
import withDialog from 'lib/alerts/with-dialog';

import Modal from 'four-nets/ui-v2/modal/modal';

import LoadingWrapperView from './loaders/loading-wrapper-view';

export default decorator((decoratorProps = {}) => Component => {
    @withDialog
    @observer
    @withInnerRef()
    class StackViewFormView extends React.Component {
        state = { loading: false, open: false };

        setLoading = loading => {
            if (this.state.loading !== loading) {
                this.setState({ loading });
            }
        };

        show = ({ form }) => {
            this.form = form;
            this.setState({ open: true });
        };

        submitDidSucceed = data => {
            this.setState({ open: false, loading: false });
            return data;
        };

        submit = () => {
            this.setLoading(true);

            this.promise = this.form.submit().then(this.submitDidSucceed).catch(this.handleError);
            return this.promise;
        };

        handleError = err => {
            this.setLoading(false);

            console.error(err, err.stack);
            let code;
            if (err.underlayingError && err.underlayingError.status) {
                code = err.underlayingError.status;
            } else {
                code = err.code;
            }
            if (code && code >= 400 && code < 500) {
                this.props.showDialog(new InfoDialog({ message: err.message }));
            } else {
                this.props.showDialog(new RetryDialog({ message: err.message, retry: this.submit }));
            }

            return Promise.reject(err);
        };

        onClose = () => {
            if (decoratorProps.onPop) {
                decoratorProps.onPop();
            }
            this.setState({ open: false });
        };

        setOpenTrue = () => {
            if (!this.state.open) {
                this.setState({ open: true });
            }
        };

        render() {
            const { innerRef, ...rest } = this.props;
            const { title, promptOnClose, genericSubmit } = decoratorProps || {};
            const { open, loading } = this.state;

            const { form } = this;
            const { submitting, dirty } = form || {};

            return (
                <Modal
                    title={title}
                    open={open}
                    onClose={this.onClose}
                    dirty={dirty || promptOnClose}
                    onAccept={genericSubmit ? this.submit : undefined}
                >
                    <LoadingWrapperView loading={loading || submitting}>
                        {form !== undefined ? (
                            <Component
                                submit={this.submit}
                                setLoading={this.setLoading}
                                {...rest}
                                close={this.onClose}
                                form={form}
                            />
                        ) : null}
                    </LoadingWrapperView>
                </Modal>
            );
        }
    }

    return StackViewFormView;
});
